module.exports = __webpack_public_path__ + "static/evertec-ad783798a52a438e0f2b7ce2ebdcc129.png";